module.exports = __webpack_public_path__ + "img/thumbsup.978ffd0c.png";